import script from "./SendResetLink.vue?vue&type=script&setup=true&lang=js"
export * from "./SendResetLink.vue?vue&type=script&setup=true&lang=js"

import "./SendResetLink.vue?vue&type=style&index=0&id=ecdddcf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecdddcf8"]])

export default __exports__